<div class="header-logged-out row align-items-center justify-content-center">
  <ftr-logo [theme]="logoThemes.Themed"></ftr-logo>
  <div class="help-button">
    <div class="elevio__help" ftrTooltip message="Help Center" [showDash]="false">
      <ftr-icon icon="HelpCircle" color="Primary" [interactive]="true" align="Top" size="ExtraLarge"> </ftr-icon>
    </div>
  </div>
</div>
